import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner.js';
import Icon from '../Icon/Icon.js';
import styles from './Button.module.scss.js';

function Button(_ref) {
  var text = _ref.text,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    iconContainerClassName = _ref.iconContainerClassName,
    className = _ref.className,
    flat = _ref.flat,
    dataTestId = _ref.dataTestId,
    secondary = _ref.secondary,
    red = _ref.red,
    primary = _ref.primary,
    isLoading = _ref.isLoading,
    hasLoading = _ref.hasLoading,
    cancel = _ref.cancel,
    link = _ref.link,
    disableOutline = _ref.disableOutline;
  var isPrimary = red || primary;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: classNames(styles.button, disabled && styles.disabled, flat && styles.flat, link && styles.link, secondary && styles.secondary, isPrimary && styles.primary, cancel && styles.cancel, disableOutline && styles.disableOutline, className),
    onClick: onClick,
    id: dataTestId,
    disabled: disabled
  }, icon || isLoading ? /*#__PURE__*/React.createElement("div", {
    className: classNames(styles['with-icon-content'], iconContainerClassName)
  }, /*#__PURE__*/React.createElement("p", {
    className: classNames(styles.text, isLoading && styles.isLoading)
  }, text), isLoading ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    relative: true,
    isLoading: true,
    size: "small",
    color: isPrimary ? 'white' : 'default',
    className: classNames(styles.icon, isLoading && styles.isLoading)
  }) : /*#__PURE__*/React.createElement(Icon, {
    className: styles.icon,
    icon: icon,
    size: "medium",
    color: iconColor
  })) : /*#__PURE__*/React.createElement("div", {
    className: hasLoading ? styles['with-icon-content'] : undefined
  }, /*#__PURE__*/React.createElement("p", {
    className: styles.text
  }, text)));
}
Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  className: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  flat: PropTypes.bool,
  dataTestId: PropTypes.string,
  secondary: PropTypes.bool,
  red: PropTypes.bool,
  primary: PropTypes.bool,
  hasLoading: PropTypes.bool,
  isLoading: PropTypes.bool,
  cancel: PropTypes.bool,
  link: PropTypes.bool,
  disableOutline: PropTypes.bool
};
Button.defaultProps = {
  disabled: false,
  icon: '',
  iconColor: null,
  flat: false,
  dataTestId: null,
  iconContainerClassName: '',
  className: '',
  secondary: false,
  onClick: null,
  red: false,
  hasLoading: false,
  isLoading: false,
  primary: false,
  cancel: false,
  link: false,
  disableOutline: false
};

export { Button as default };
